import { supabase } from "@/integrations/supabase/client";
import { ensureProfile } from "@/lib/ensureProfile";
import { computeDashboardDest } from "@/lib/computeDashboardDest";

export async function postAuthHandoff(
  roleHint: "employer" | "job_seeker" | undefined,
  next?: string
) {
  console.log("🚀 [POSTAUTH] Starting postAuthHandoff for role:", roleHint);
  
  const { data: { user } } = await supabase.auth.getUser();
  const uid = user?.id;
  if (!uid) {
    console.error("❌ [POSTAUTH] No user ID found");
    return;
  }

  console.log("🔍 [POSTAUTH] User ID:", uid);

  // guard: run once per auth
  if (sessionStorage.getItem("postAuthRan") === "1") {
    console.log("⚠️ [POSTAUTH] Already ran, skipping");
    return;
  }
  sessionStorage.setItem("postAuthRan", "1");

  // Determine effective role (prefer explicit hint, then session intent, default to job_seeker)
  const sessionIntent = ((): "employer" | "job_seeker" | null => {
    try {
      const v = sessionStorage.getItem("login_intent_role");
      return v === "employer" || v === "job_seeker" ? v : null;
    } catch {
      return null;
    }
  })();
  const effectiveRole: "employer" | "job_seeker" = (roleHint || sessionIntent || "job_seeker");

  console.log('🔍 [POSTAUTH] handoff', { roleHint, sessionIntent, effectiveRole, hasNext: !!next });

  // ensure profile exactly once here
  console.log("🔧 [POSTAUTH] Calling ensureProfile...");
  try {
    await ensureProfile(uid, effectiveRole);
    console.log("✅ [POSTAUTH] ensureProfile completed successfully");
  } catch (error) {
    console.error("❌ [POSTAUTH] ensureProfile failed:", error);
  }

  // allow first protected-route pass without bouncing
  sessionStorage.setItem("skipProtectedOnce", "1");

  // compute destination (or honor ?next)
  console.log("🔧 [POSTAUTH] Computing destination...");
  const dest = next || await computeDashboardDest({ supabase });
  console.log("🎯 [POSTAUTH] Destination:", dest);

  // clear intent
  sessionStorage.removeItem("login_intent_role");
  sessionStorage.removeItem("login_intent_next");
  sessionStorage.removeItem("referral_code");

  // navigate
  console.log("🚀 [POSTAUTH] Navigating to:", dest);
  window.location.replace(dest);
}
